import { AnalyticsEventName } from "models/analytics";


export const EventTrackByRedux: { [key: string]: AnalyticsEventName } = {
    "paymentModel/openPaymentModal": "UpgradeClose",
    "@@app/updateDetailHabit": 'ViewSingleProgressScreen',
    "appModel/updateTimerOverlay": 'StartTimer',
    "habitsModel/openEditHabit": 'EditHabit',
}
